"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@awesome.me/kit-c10ef98ed3/icons/classic/regular";
import { faSpinnerThird } from "@awesome.me/kit-c10ef98ed3/icons/duotone/solid";

export interface ProcessingStateProps {
  text: string;
  isActive: boolean;
  isComplete: boolean;
  dataCy?: string;
  t: (key: string) => string;
}

export default function ProcessingState({
  text,
  isActive,
  isComplete,
  dataCy,
  t,
}: ProcessingStateProps) {
  const iconClass = [
    "processing-state-icon",
    !isActive && !isComplete ? "is-hidden" : "",
    isActive && !isComplete ? "is-spinning" : "",
  ]
    .filter(Boolean)
    .join(" ");

  const textClass = [
    "processing-state-text",
    isActive ? "is-active" : "",
    isComplete ? "is-complete" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="processing-state" data-cy={dataCy}>
      <div className={iconClass}>
        {isComplete ? (
          <FontAwesomeIcon icon={faCheck} aria-label={t("checkmark")} />
        ) : (
          <FontAwesomeIcon
            icon={faSpinnerThird}
            aria-label={t("loading-spinner")}
          />
        )}
      </div>
      <span className={textClass} data-cy={`${dataCy}-text`}>
        {text}
      </span>
    </div>
  );
}
